import { useState } from 'react';
import { DEFAULT_DOSE, DEFAULT_PRESETS, PRESETS_STORAGE_KEY } from '../shared/constants.js';
import { useLocalStorageState } from '../shared/db.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import DoseSelector from './DoseSelector.js';
import RoundModal from './RoundModal.js';
import './AddNewDoseModal.css';

const AddNewDoseModal = ({ onSave, onClose }) => {
    const [dose, selectDose] = useState(DEFAULT_DOSE.toString());
    const [presets] = useLocalStorageState(PRESETS_STORAGE_KEY, DEFAULT_PRESETS);
    const { language } = useLanguage();
    const i18n = usei18n(language);

    return (
        <RoundModal onClose={onClose} onBackdropClick={onClose} id="add-new-dose-modal-panel">
            <div className="add-new-dose-modal">
                <DoseSelector presets={presets} selected={dose} selectDose={selectDose} />
                <button
                    type="button"
                    className="confirm-dose"
                    onClick={() => onSave(dose)}
                    aria-label={i18n('modal.addDose.save')}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 12l5 5L20 6" />
                    </svg>
                </button>
            </div>
        </RoundModal>
    )
}

export default AddNewDoseModal;
